import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { navigationService } from 'vue-spatialnavigation';
import { RailItemResponse, RailResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { useRailNavigation } from '@/composables/useRailNavigation';
import { useCMSItemNavigation } from '@/composables/useCMSItemNavigation';
import SplitPanelItem from '@/components/rails/SplitPanelItem.vue';
import GlyphView  from '@/components/glyphs/GlyphView.vue';
import { focusElementById } from '@/helpers/focus';


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitPanelRail',
  props: {
    rail: null,
    railIndex: null,
    railDidNavigateDown: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
  railIndex: number;
  railDidNavigateDown?: (railIndex: number) => void;
};




const { itemId, handleUp, handleDown, handleLeftFallback } = useRailNavigation(props);
const { openItem } = useCMSItemNavigation();

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const localised = (en: string | null, ga: string | null) => {
  const value = currentLanguage.value === Language.Irish ? ga : en;
  return value ?? en ?? '';
};

const title = computed(() => localised(props.rail.titleEn, props.rail.titleGa));
const subtitle = computed(() => localised(props.rail.subtitleEn, props.rail.subtitleGa));

const items = computed(() => props.rail.items);

const stacked = computed(() => items.value.length > 2);

const paneStyle = computed(() => ({
  'background-color': props.rail.backgroundColor ?? undefined,
  color: props.rail.textColor ?? undefined,
}));

const itemKey = (item: RailItemResponse, index: number) => {
  switch (item.type) {
    case 'SERIES':
      return `${item.series.slug}-${index}`;
    case 'VIDEO':
      return `${item.video.vid}-${index}`;
    case 'CATEGORY':
      return `${item.category.slug}-${index}`;
    default:
      return `item-${index}`;
  }
};

const focusItem = (index: number) => {
  const focusElement = navigationService.getFocusElementById(itemId(index));
  if (!focusElement) return;

  // if (document.activeElement instanceof HTMLElement) {
  //   document.activeElement.blur();
  // }

  // focusElement.focus();
  focusElementById(focusElement.id, { scroll: true });
};

/** Within the pane along its own axis, otherwise out of the rail entirely. */
const movePrevious = (index: number) => {
  if (index > 0) {
    focusItem(index - 1);
    return;
  }
  handleUp();
};

const moveNext = (index: number) => {
  if (index < items.value.length - 1) {
    focusItem(index + 1);
    return;
  }
  handleDown();
};

const moveUp = (index: number) => (stacked.value ? movePrevious(index) : handleUp());
const moveDown = (index: number) => (stacked.value ? moveNext(index) : handleDown());

// Left out of the first item leaves the rail, matching HorizontalScroller.
const moveLeft = (index: number) => {
  if (stacked.value || index === 0) {
    handleLeftFallback();
    return;
  }
  focusItem(index - 1);
};

const moveRight = (index: number) => {
  if (stacked.value) return;
  if (index < items.value.length - 1) focusItem(index + 1);
};

const rootRef = ref<HTMLElement | null>(null);
const lazyLoad = getCurrentInstance()?.proxy?.$lazyLoad;

const scanForLazyImages = () => {
  setTimeout(() => {
    if (rootRef.value) lazyLoad?.(rootRef.value);
  }, 200);
};

onMounted(scanForLazyImages);


return { __sfc: true,props, itemId, handleUp, handleDown, handleLeftFallback, openItem, useGetter, currentLanguage, localised, title, subtitle, items, stacked, paneStyle, itemKey, focusItem, movePrevious, moveNext, moveUp, moveDown, moveLeft, moveRight, rootRef, lazyLoad, scanForLazyImages, SplitPanelItem, GlyphView }
}

})